import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalProductSearchGateway } from '../gateway/global-product-search.gateway';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { BOProductSearchPage } from '@boels/models';
import { of } from 'rxjs';
import {
  LOAD_GLOBAL_PRODUCT_SEARCH_PAGE,
  loadGlobalProductSearchPageFail,
  loadGlobalProductSearchPageSuccess,
} from '../actions/global-product-search.action';

@Injectable({
  providedIn: 'any',
})
export class GlobalProductSearchEffects {
  private actions$ = inject(Actions);
  private globalProductSearchGateway = inject(GlobalProductSearchGateway);

  loadGlobalProductSearchPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_GLOBAL_PRODUCT_SEARCH_PAGE),
      switchMap((action) => {
        return this.globalProductSearchGateway
          .getGlobalProductSearchPage(
            action['query'],
            action['pageSize'],
            action['currentPage'],
            action['sortCode'],
          )
          .pipe(
            map((boProductSearchPage: BOProductSearchPage) =>
              loadGlobalProductSearchPageSuccess({
                productSearchPage: boProductSearchPage,
                currentPage: action['currentPage'],
              }),
            ),
            catchError((errorMessage) =>
              of(loadGlobalProductSearchPageFail({ errorMessage })),
            ),
            first(),
          );
      }),
    ),
  );
}
